<template>
  <div>
    <!-- Modal -->
    <div class="modal fade" id="addQuoteRequestModal" ref="modalEle" tabindex="-1" role="dialog"
         aria-labelledby="modelTitleId"
         aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Generuj ruch - {{ selectedItem?.[0]?.document_number ?? '' }}</h5>
            <button type="button" class="close ms-auto" data-bs-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <label>Powód</label>
            <input id="reason" type="text" name="reason" class="form-control form-control-sm">

            <label>Osoba odbierająca</label>
            <input id="person_receive" type="text" name="person_receive" class="form-control form-control-sm">

            <label>Data podpisania dokumentu</label>
            <input id="signed_date" type="date" name="signed_date" class="form-control form-control-sm">

            <label>Dodatkowy komentarz</label>
            <input id="additional_comment" type="text" name="additional_comment" class="form-control form-control-sm">

            <div class="float-end">
              <button class="btn btn-primary btn-sm mt-4" type="button" :disabled="generatingPDF"
                      @click="generateDocument">
                Generuj PDF
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {Modal, Tooltip} from "bootstrap";
import {useForm, usePage} from "@inertiajs/vue3";
import {DatePickerComponent} from "@syncfusion/ej2-vue-calendars";
import Index from "../../OrderLists/Index.vue";

export default {
  components: {Index, 'ejs-datepicker': DatePickerComponent},
  props: {
    selectedItem: Object,
  },

  data() {

    return {
      generatingPDF: false,
      documentType: 'pw'
    }
  },


  async mounted() {
    this.modalObj = new Modal(this.$refs.modalEle);
  },

  methods: {

    async generateDocument() {
      this.generatingPDF = true;
      this.documentType = this.getDocumentType();

      let data = {
        reason: document.getElementById("reason").value,
        person_receive: document.getElementById("person_receive").value,
        signed_date: document.getElementById("signed_date").value,
        additional_comment: document.getElementById("additional_comment").value,
        document_type: this.documentType,
        movements: this.selectedItem
      };

      try {
        const response = await axios.post(route('warehouse-movements.previewPDF'), data, {
          responseType: 'blob',
        });

        const blob = new Blob([response.data], {type: 'application/pdf'});
        const pdfUrl = URL.createObjectURL(blob);
        window.open(pdfUrl, '_blank');
      } catch (error) {
        console.error('Error generating PDF preview:', error);
      } finally {
        this.generatingPDF = false; // Reset generatingPDF when done
      }
    },

    getDocumentType() {
      if (!this.selectedItem && this.selectedItem.length === 0) {
        return 'pw'; // domyślnie
      }

      // możliwe typy:
      // PW, MM, RW, WZ
      const number = this.selectedItem[0]?.document_number;
      return number.slice(0, 2).toLowerCase();
    },

    hasError(field) {
      return this.errors && this.errors[field];
    },

    show() {
      if (this.modalObj) {
        this.modalObj.show();
      }
    },

    hide() {
      if (this.modalObj) {
        this.modalObj.hide();
      }
    },
  }
}
</script>